// Refactored ApproachSelect.tsx using ApproachContext
import React, { FC, useEffect, useState } from 'react';
import ApproachViewer from './ApproachViewer';
import ApproachTable from './ApproachTable';
import { LoadingSpinner } from '../../icons/OurIcons';
import { useApproachContext } from '../../../contexts/DecisionMaking/ApproachContext';

const ApproachSelect: FC = () => {
  const [ selectedApproachIndex, setSelectedApproachIndex ] = useState<number | null>(null);
  const {
    calculatedApproaches,
    selectedApproach,
    isLoadingApproaches,
    isErrorApproaches,
    handleApproachChange,
  } = useApproachContext();

  useEffect(() => {
    if (!selectedApproach || !calculatedApproaches.length) {
      setSelectedApproachIndex(null);
      return;
    }
    const index = calculatedApproaches.findIndex((a) => a.approach.id === selectedApproach.approach.id);
    setSelectedApproachIndex(index !== -1 ? index : null);
  }, [ selectedApproach, calculatedApproaches ]);

  const ApproachContent = () => {
    if (isLoadingApproaches) {
      return (
        <div className='flex items-center justify-center h-96'>
          <LoadingSpinner />
        </div>
      );
    }

    if (isErrorApproaches || !calculatedApproaches.length) {
      return (
        <div className='flex items-center justify-center h-96'>
          <div className='text-center'>No Approach Data</div>
        </div>
      );
    }

    return (
      <>
        <ApproachTable
          calculatedApproaches={calculatedApproaches}
          selectedApproachIndex={selectedApproachIndex}
          handleApproachChange={handleApproachChange}
        />
        <ApproachViewer selectedApproach={selectedApproach} />
      </>
    );
  };

  return (
    <div id='approach-select' className='w-contain content-center justify-content-center'>
      <div className='flex justify-between m-3 items-center'>
        <h3 className='whitespace-nowrap text-extrabold text-lg text-indigo-500'>Approaches</h3>
        <a
          href='/configurations'
          target='_blank'
          className='rounded bg-indigo-600 px-2 py-2 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500'
        >
          Manage Approaches
        </a>
      </div>
      <hr className='mt-3 mb-4 mx-3' />
      <ApproachContent />
    </div>
  );
};

export default ApproachSelect;
